import type { FaireProductEntity } from "../../entity_types/product";

export const p_kp845dmm3w: FaireProductEntity = {
  token: "p_kp845dmm3w",
  type: "product",
  name: "Newborn Knotted Gown - Slugger",
  brandToken: "b_qba2f8n5gh",
  brandName: "Copper Pearl",
  imageUrl:
    "https://cdn.faire.com/fastly/202a8ae0cc7c11c24e91c4a60980d94025f22a1e0caca35a362b8a174b9c89e5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4afd7c0f4c1ed35d9deb075d5c7b9c5572782c831ea31915e7c7763aacdce4b6.jpeg",
    "https://cdn.faire.com/fastly/898f3444e9a6b0a9223e210fbe59aced07e9ae4cd5e81e0c6a083d88e6199b39.jpeg",
    "https://cdn.faire.com/fastly/6195fb10d41fa36c2f7cb628ee39c6e4945c24e8cfa99c278c6f6d28e972ba02.jpeg",
    "https://cdn.faire.com/fastly/2c6bc5a6ebe768e9df2b63199a0b85737e27fe71553d3ad9599f66f9c31256dd.jpeg",
  ],
  priceDollars: 14,
  description:
    "* \nPREMIUM POLYESTER/RAYON BLEND – Made with the same premium knit fabric as our beloved swaddles, this soft and stretchy gown ties at the bottom for easy diaper changes—and has room to grow.\n\n * GENEROUS SIZE – A length of 25 inches and width of 8 inches. \n * \nBONUS FEATURES – Our knotted gowns feature unique snaps to make dressing a breeze, along with fold-over hand mitts to prevent scratching.\n\n * \nTRENDY, HIGH QUALITY DESIGNS – At Copper Pearl we pride ourselves on making high quality products that always look great on babies, moms, or in your nursery. Our knotted gowns are simple, modern, and sure to elevate any baby’s style.\n\n * \nPAIR PERFECTLY WITH COPPER PEARL PRODUCTS – Our trendy, newborn knotted gowns flaunt your favorite Copper Pearl prints and patterns. They are made to coordinate perfectly with products you already own and love!",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:09.925Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
